import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=1c38d7f0&scoped=true"
import script from "./Distribution.vue?vue&type=script&lang=js"
export * from "./Distribution.vue?vue&type=script&lang=js"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=1c38d7f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38d7f0",
  null
  
)

export default component.exports